// extracted by mini-css-extract-plugin
export default {"listcontainer":"productlist_listcontainer__9eVWX"};